<ng-container *ngIf="field">
  <div class="flex flex-wrap input-field-container">
	<p-checkbox [binary]="true" (onChange)="onSelect($event)" [formControl]="control"></p-checkbox>
    <label *ngIf="field.DisplayText">{{ field.DisplayText }}</label>
  </div>
</ng-container>
